import BaseListPresenter from "../../../../../base/BaseListPresenter";
import { getHeader } from "./headers/BasicEarningsHeader";
import {
  mergeHeaders,
  convertLabels,
} from "../../../Payroll/helper-payroll/HelperFunction";
import { isAddendumBackPayItem } from "../../../Payroll/helper-payroll/constants/payrollConstants";

class BasicEarningsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  async componentDidMount() {
    // const { fetchPayrolls, panelInfo } = this.view.props;
    const { deductions, contributionType } = this.view.props.panelInfo;

    const args = {
      deductions,
      contributionType,
    };

    console.log("contributionType", contributionType);

    // console.log("fetchPayrolls", fetchPayrolls);

    const [tableHeader, primarySubHdr, secondarySubHdr] = getHeader(args);
    const params = [tableHeader, primarySubHdr, secondarySubHdr];

    const mergedResult = mergeHeaders(...params);
    const convertedHeaders = convertLabels(mergedResult);

    console.log("convertedHeaders", convertedHeaders);

    const tableHeaders = {
      tableHeader,
      primarySubHdr,
      convertedHeaders,
    };

    // console.log("convertedHeaders", convertedHeaders);
    // console.log("mergedResult", mergedResult);

    this.init();
    this.getObjects();
    this.view.setState({ tableHeaders });
  }
  init() {
    const { employeeInfo, payrollIds, payrollPrinted, deductions } =
      this.view.props.panelInfo;

    console.log("DEDUSCTIONJSSS", deductions);

    console.log("payrollPrinted", payrollPrinted);
    const employeeId = employeeInfo?.id;
    console.log("payrollIds", payrollIds);

    console.log("employeeId", employeeId);

    this.limit = 10;
    this.where = {
      payrollID: { $in: payrollIds },
      "employee.id": employeeId,
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;

    console.log("skip", skip);
    const query = {
      limit: this.limit,
      // skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const { employeeInfo, backPayIds } = this.view.props.panelInfo;
    const employeeId = employeeInfo?.id;
    const query = this.createQuery();
    console.log("query", query);
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      // const objects = await
      const [objects, backpay] = await Promise.all([
        this.findObjectUseCase.execute(collection, query),
        this.findObjectUseCase.execute("payroll_back_pay", {
          where: {
            payrollID: { $in: backPayIds },
            "employee.id": employeeId,
          },
        }),
      ]);
      console.log("BACKKKM PAYYYs ", backpay);
      console.log("objects3q23213", objects);
      const tableObjects = this._getTableObjects(objects, backpay);
      console.log("tableObjects", tableObjects);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(tableObjects);
      this.view.setState({ isLoading: false });
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  _getTableObjects(objects, backpay) {
    console.log("BACCCKKKKKK", backpay);
    console.log("OBJECT", objects);
    const result = [];

    // Process main objects
    for (let i = 0; i < objects.length; i++) {
      const obj = objects[i];
      let formattedObject = {
        id: obj.id,
        payrollPeriod: `${obj.startDate} - ${obj.endDate}`,
        payrollType: `${obj.payrollType} - ${obj.jobType} - ${obj.payItem}`,
        basic: obj.oldRate,
        pera: obj.peraAda,
        netPay: obj?.netAmount,
      };

      const cases = this._getCases(obj);

      if (cases.firstCase) {
        formattedObject.earnedBasic = obj?.earnedBasic;
        formattedObject.earnedPeraAda = obj?.earnedPeraAda;
        formattedObject.overpaymentBasic = obj?.overpaymentBasic ?? 0;
        formattedObject.overpaymentPeraAda = obj?.overpaymentPeraAda ?? 0;
      } else if (cases.secondCase) {
        formattedObject.daysToBeDeducted = obj?.daysToBeDeducted;
        formattedObject.halfDaysToBeDeducted = obj?.halfDaysToBeDeducted;
        formattedObject.minutesToBeDeducted = obj?.minutesToBeDeducted;
        formattedObject.gsisInsuredDays = obj?.gsisInsuredDays;
        formattedObject.deductionDueToLeavesLeavesAbsencesAndTardinessBasic =
          obj.deductionDueToLeavesTardy;
        formattedObject.deductionPeraAda = obj?.deductionPeraAda;
        formattedObject.overpaymentBasic = obj?.overpaymentBasic ?? 0;
        formattedObject.overpaymentPeraAda = obj?.overpaymentPeraAda ?? 0;
        formattedObject.tax = obj?.tax;
      }

      this._parseKeyValueArrayToObject(formattedObject, obj.contributions);
      this._parseKeyValueArrayToObject(formattedObject, obj.deductions);

      result.push(formattedObject);
    }

    if (Array.isArray(backpay)) {
      for (let i = 0; i < backpay.length; i++) {
        const obj = backpay[i];
        let formattedObject = {
          id: obj.id,
          payrollType: `${obj.payrollType} - ${obj.jobType} - ${obj.payItem}`,
          basic: obj.oldRate,
          pera: obj.peraAda,
          payrollPeriod: Array.isArray(obj.netAmount)
            ? obj.netAmount.map((entry) => entry.split(" - ")[0].trim())
            : [],
        };

        const cases = this._getCases(obj);

        if (cases.thirdCase) {
          formattedObject.basicRateForBackPay = obj.basicRateForBackPay;
          formattedObject.peraAdaForBackPay = obj.peraAdaForBackPay;
          formattedObject.peraAdaForBackPay = obj.peraAdaForBackPay;
          formattedObject.daysToBeDeducted = obj.daysToBeDeducted;
          formattedObject.halfDaysToBeDeducted = obj.halfDaysToBeDeducted;
          formattedObject.minutesToBeDeducted = obj.minutesToBeDeducted;
          formattedObject.gsisInsuredDays = obj.gsisInsuredDays;
          formattedObject.deductionDueToLeavesLeavesAbsencesAndTardinessBasic =
            obj.deductionDueToLeavesTardy;
          formattedObject.deductionPeraAda = obj.deductionPeraAda;
          formattedObject.overpaymentBasic = obj.overpaymentBasic;
          formattedObject.overpaymentPeraAda = obj.overpaymentPeraAda;
          formattedObject.earnedBasic = obj.earnedBasic;
          formattedObject.earnedPeraAda = obj.earnedPeraAda;
          formattedObject.tax = obj.tax;
          formattedObject.netPay = obj.netAmount;
          // formattedObject.earnedPeraAda = obj.earnedPeraAda;
          // formattedObject.earnedPeraAda = obj.earnedPeraAda;
          // formattedObject.earnedPeraAda = obj.earnedPeraAda;
        } else if (cases.secondCase) {
        }
        this._parseKeyValueArrayToObject(formattedObject, obj.contributions);
        this._parseKeyValueArrayToObject(formattedObject, obj.deductions);
        result.push(formattedObject);
      }
    }

    return result;
  }

  _getCases(obj) {
    return {
      firstCase:
        obj.payrollType === "Basic Pay" && obj.payItem === "General Payroll",

      secondCase:
        obj.payrollType === "Basic Pay" &&
        obj.jobType !== "Job Order" &&
        obj.payItem === "Addendum Payroll",

      thirdCase:
        obj.payrollType === "Basic Pay" && isAddendumBackPayItem(obj.payItem),
    };
  }

  _parseKeyValueArrayToObject(target, array) {
    if (!Array.isArray(array)) return;

    array.forEach((entry) => {
      const [key, value] = entry.split(":").map((x) => x.trim());
      if (key && value !== undefined) {
        if (
          value.includes(",") &&
          value.split(",").every((v) => !isNaN(v.trim()))
        ) {
          // Handle comma-separated numeric values
          target[key] = value.split(",").map((v) => parseFloat(v.trim()));
        } else {
          // Original logic
          target[key] = isNaN(value) ? value : parseFloat(value);
        }
      }
    });
  }
}
export default BasicEarningsPresenter;
